/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyZeplinIconComponent = lazyForPaint(
	() => import(/* webpackChunkName: "icon-zeplin" */ './utils').then((m) => m.ZeplinIcon),
	{ moduleId: '@atlassian/rovo-connectors-config/zeplin/icon' },
);

const LazyZeplinSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-zeplin-search-result" */ './utils').then(
			(m) => m.ZeplinSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/zeplin/search-result-icon' },
);

const LazyZeplinIconBorderlessComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-zeplin-borderless" */ './utils').then(
			(m) => m.ZeplinIconBorderless,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/zeplin/icon-borderless' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const ZeplinIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyZeplinIconComponent />
	</Suspense>
);

export const ZeplinSearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyZeplinSearchResultIconComponent />
	</Suspense>
);

export const ZeplinIconBorderless = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyZeplinIconBorderlessComponent />
	</Suspense>
);
